(function () {
  const outingEventsHandicapsApp = function () {
    const bindImportFromUsga = () => {
      $(document).on('click', '.import-from-usga', function (e) {
        window.stopEvent(e);

        const url = $(this).data('url');
        window.swalConfirm
          .fire({
            text: 'Import handicap index from Course database?',
            confirmButtonText: 'Yes',
          })
          .then((result) => {
            if (!result.isConfirmed) return;

            $('.loader.generic-loader').removeClass('d-none');
            $.ajax({
              method: 'POST',
              url,
              success: function () {
                window.location.reload();
              },
            });
          });
      });
    };

    const bindNaHandicaps = () => {
      $('.na-hdcp').on('change', function () {
        if (!$(this).prop('checked')) return;

        $(this).closest('tr').find('input[type=number]').val('');
      });
    };

    const bindChangeInputs = () => {
      $("[name*='usgas['], [name*='handicaps['], [name*='player_usgas['], [name*='player_handicaps[']").on(
        'change',
        function () {
          const name = $(this).attr('name');
          const isUsga = name.includes('usga');
          const scope = $(this).parent().parent();

          if (isUsga) $(scope).find('input:not([name*=usga])').val('');
          else $(scope).find('input[name*=usga]').val('');
        }
      );
    };

    const bindHdcpTabs = () => {
      $(document).on('click', '#hdcp-tabs .nav-link', function (e) {
        e.preventDefault();
        $('#hdcp-tabs .nav-link').removeClass('active');
        $(this).addClass('active');

        const filter = $(this).data('hdcpFilter');
        if (filter === 'all') {
          $('.hdcp-section').show();
        } else {
          $('.hdcp-section').hide();
          $(`.hdcp-section[data-hdcp-section="${filter}"]`).show();
        }
      });
    };

    $(document).on('turbolinks:load', () => {
      if (!$('body').hasClass('controller-outings-handicaps')) return;

      bindImportFromUsga();
      bindNaHandicaps();
      bindChangeInputs();
      bindHdcpTabs();
    });
  };

  if (typeof window !== 'undefined') {
    window.outingEventsHandicapsApp = outingEventsHandicapsApp();
  }
})();
